import axios from "axios"
import ApiService from "./ApiService"

class UnitsApiService extends ApiService {
	static async deleteUnit(unitId) {
		await fetch(`${super.getBaseUrl()}/units/${unitId}`, {
			method: "DELETE",
			headers: {
				"X-Access-Token": super.getAccessToken(),
				"Content-Type": "application/json"
			}
		})
	}

	static async getUnit(unitId) {
		const response = await fetch(`${super.getBaseUrl()}/units/${unitId}`, {
			headers: {
				"X-Access-Token": super.getAccessToken(),
				"Content-Type": "application/json"
			}
		})
		return await response.json()
	}

	static async getUnits() {
		const response = await fetch(`${super.getBaseUrl()}/units`, {
			headers: {
				"X-Access-Token": super.getAccessToken(),
				"Content-Type": "application/json"
			}
		})
		return await response.json()
	}

	static async saveUnit(unitData, unitId) {
		const url = `${super.getBaseUrl()}/units${unitId ? `/${unitId}` : ''}`
		try {
			const response = await axios.post(url, unitData, {
				headers: {
					"X-Access-Token": super.getAccessToken(),
					"Content-Type": "application/json"
				}
			})
			return response.data
		} catch ({ response }) {
			throw response.data
		}
	}
}

export default UnitsApiService



// WEBPACK FOOTER //
// ./src/api/UnitsApiService.js